import * as React from "react";

function SvgPointillist(props, ref) {
  return (
    <svg
      id="Pointillist_svg__Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      x={0}
      y={0}
      width="1em"
      height="1em"
      viewBox="90 0 252.3 141.7"
      xmlSpace="preserve"
      {...{ ...props, ref }}
    >
      <style>
        {
          ".Pointillist_svg__st0{fill:#76c4d5}.Pointillist_svg__st1{fill:#00837e}.Pointillist_svg__st2{fill:#00b4aa}"
        }
      </style>
      <path
        className="Pointillist_svg__st0"
        d="M274.5 47c2 0 3.7.7 5.1 2.1 1.4 1.4 2.1 3.1 2.1 5.1 0 1.9-.7 3.6-2.1 5-1.4 1.4-3.1 2.1-5.1 2.1-1.9 0-3.6-.7-5-2.1-1.4-1.4-2.1-3.1-2.1-5 0-2 .7-3.7 2.1-5.1 1.4-1.4 3.1-2.1 5-2.1z"
      />
      <circle className="Pointillist_svg__st1" cx={146} cy={62.7} r={2.7} />
      <circle className="Pointillist_svg__st1" cx={150.8} cy={42.8} r={4} />
      <circle className="Pointillist_svg__st1" cx={161.9} cy={24.3} r={4.8} />
      <circle className="Pointillist_svg__st2" cx={182.5} cy={10.7} r={5.4} />
      <circle className="Pointillist_svg__st2" cx={209.9} cy={5.9} r={5.9} />
      <circle className="Pointillist_svg__st2" cx={236.8} cy={9.3} r={6.8} />
      <circle className="Pointillist_svg__st0" cx={262.3} cy={26.6} r={7.1} />
      <path
        className="Pointillist_svg__st1"
        d="M149.7 138.3c0 .6-.2 1.1-.6 1.5-.4.4-.9.6-1.4.6H142c-.5 0-1-.2-1.4-.6-.4-.4-.6-.9-.6-1.5l.4-62.3c0-.6.2-1.1.6-1.4.4-.4.9-.6 1.4-.6h4.8c.6 0 1.1.2 1.5.6.4.4.6.9.6 1.5l.4 62.2z"
      />
      <path
        className="Pointillist_svg__st0"
        d="M278.9 138.3c0 .6-.2 1.1-.6 1.5-.4.4-.9.6-1.4.6h-5.7c-.5 0-1-.2-1.4-.6-.4-.4-.6-.9-.6-1.5l.4-62.3c0-.6.2-1.1.6-1.4.4-.4.9-.6 1.4-.6h4.8c.6 0 1.1.2 1.5.6.4.4.6.9.6 1.5l.4 62.2z"
      />
    </svg>
  );
}

export default React.forwardRef(SvgPointillist);
